import React, { FC, useState } from "react";
import { Link, useLocation } from "wouter";
import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import { register, RegisterResponse, authErrorMessage } from "@/api/auth_api.ts";
import { AxiosError } from "axios";
import { loginState } from "@/states.ts";

export const Errors: FC<{ errors: Record<string, string[]> | undefined; field: string }> = (
	props,
) => {
	const { errors, field } = props;
	if (!errors?.[field]) return null;
	return (
		<div className={"text-red-500"}>
			{errors[field].map((e) => (
				<div key={e}>{e}</div>
			))}
		</div>
	);
};

export const FormError: FC<{ error?: string }> = ({ error }) =>
	error ? <div className={"text-red-500"}>{error}</div> : null;

const RegistrationPage: React.FC = (props) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [password2, setPassword2] = useState("");
	const [errors, setErrors] = useState<RegisterResponse["errors"]>(undefined);
	const [formError, setFormError] = useState<string>();
	const [ts, setTs] = useState(false);
	const [beta, setBeta] = useState(false);
	const [location, setLocation] = useLocation();
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.BaseSyntheticEvent) => {
		e.preventDefault();
		setLoading(true);
		setFormError(undefined);
		let errors: Record<string, string[]> = {};

		if (!ts) {
			errors.ts = ["Required"];
		}

		if (!beta) {
			errors.beta = ["Required"];
		}

		setErrors(errors);
		if (!beta || !ts) {
			setLoading(false);
			return;
		}

		try {
			const response = await register(email, password, password2);
			setLoading(false);
			if (response.ok && response.token) {
				loginState.token = response.token;
				setLocation("/");
			}
		} catch (e) {
			setLoading(false);
			if (e instanceof AxiosError && e.response?.data?.errors) {
				setErrors(e.response.data.errors);
			}
			setFormError(authErrorMessage(e));
			return;
		}
	};

	return (
		<div className={"flex justify-center items-center h-screen"}>
			<form
				onSubmit={handleSubmit}
				target={"#"}
				className={"flex flex-col gap-4 flex-1 w-full max-w-[300px] p-4"}
			>
				<h2 className={"text-xl font-bold"}>Register</h2>
				<FormError error={formError} />
				<label>
					Email
					<Input
						type="text"
						name={"email"}
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<Errors errors={errors} field={"email"} />
				</label>
				<label>
					Password
					<Input
						type="password"
						name={"password"}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<Errors errors={errors} field={"password"} />
				</label>
				<label>
					Confirm Password
					<Input
						type="password"
						name={"password2"}
						value={password2}
						onChange={(e) => setPassword2(e.target.value)}
					/>
					<Errors errors={errors} field={"password2"} />
				</label>
				<label className={"cursor-pointer"}>
					<input
						type={"checkbox"}
						className={"mr-2"}
						checked={ts}
						onChange={(e) => setTs(e.target.checked)}
					/>
					I accept the{" "}
					<a
						className={"text-primary"}
						href={"https://tawnylist.com/terms"}
						target={"_blank"}
					>
						Terms and conditions
					</a>
					.
				</label>
				<Errors errors={errors} field={"ts"} />
				<label className={"cursor-pointer"}>
					<input
						type={"checkbox"}
						className={"mr-2"}
						checked={beta}
						onChange={(e) => setBeta(e.target.checked)}
					/>
					I understand TawnyList is in Beta and might encounter bugs.
				</label>
				<Errors errors={errors} field={"beta"} />
				<div className={"flex justify-between items-center"}>
					<Button
						type={"submit"}
						className={"w-full sm:w-6/12"}
						disabled={loading}
					>
						Register
					</Button>
					<Link
						className={"text-secondary-foreground/80"}
						to={"/login"}
					>
						Login
					</Link>
				</div>
			</form>
		</div>
	);
};

export { RegistrationPage };
